import { ReactElement } from 'react';

export type LanguageTypes = {
  languageId: string;
  locale: string;
  apiLanguage: string;
  name: string;
  icon: ReactElement;
  displayName: string;
  contextPath: string;
};

export const languages: { [key: string]: LanguageTypes } = {
  VI: {
    languageId: 'vietnamese',
    locale: 'vi',
    apiLanguage: 'VN',
    name: 'Tiếng Việt',
    icon: (
      <i className="icon-language-vn-circle_24x24">
        <span className="path1"></span>
        <span className="path2"></span>
      </i>
    ),
    displayName: 'VI',
    contextPath: process.env.REACT_APP_CONTEXT_PATH_VI,
  },
  JP: {
    languageId: 'JAPANESE',
    locale: 'jp',
    apiLanguage: 'JP',
    name: '日本語',
    icon: (
      <i className="icon-language-jp-circle_24x24">
        <span className="path1"></span>
        <span className="path2"></span>
      </i>
    ),
    displayName: 'JP',
    contextPath: process.env.REACT_APP_CONTEXT_PATH_JP,
  },
  EN: {
    languageId: 'english',
    locale: 'en',
    apiLanguage: 'EN',
    name: 'English',
    icon: (
      <i className="icon-language-en-circle_24x24">
        <span className="path1"></span>
        <span className="path2"></span>
        <span className="path3"></span>
        <span className="path4"></span>
        <span className="path5"></span>
        <span className="path6"></span>
        <span className="path7"></span>
        <span className="path8"></span>
        <span className="path9"></span>
        <span className="path10"></span>
        <span className="path11"></span>
        <span className="path12"></span>
        <span className="path13"></span>
        <span className="path14"></span>
      </i>
    ),
    displayName: 'EN',
    contextPath: process.env.REACT_APP_CONTEXT_PATH_EN,
  },
};
